import { usePrevious, useUpdateEffect } from '@react-hookz/web';
import { EffectCallback } from 'react';
import { useSelectUser } from 'redux/User/selectors';

export const useEffectOnUnitSystemChange = (effect: EffectCallback): void => {
  const user = useSelectUser();

  const previousUnitSystem = usePrevious(user?.unitSystem);

  useUpdateEffect(() => {
    if (!previousUnitSystem) return;
    effect();
  }, [user?.unitSystem]);
};
